import utils from 'utils'
import authenticationModalTemplate from '../../../main/common/authenticationModalList.html'
class inputDownloadProgressCtrl {
    constructor($scope, $timeout, $filter, $uibModalInstance, logger, items1, httpRequest) {
        console.log(items1)
        $scope.returnBtn = false //返回列表
        $scope.stopSynBtn = true //停止下载
        let getListApi
        let invoiceFileType //  PDF:1,OFD:2,XML:3
        if(items1.fileType == 'OFD'){
            getListApi = 'post_downOfdInvoiceFile'
            invoiceFileType='2'
        }else if(items1.fileType == 'PDF'){
            getListApi = 'post_ivatDownPdfInvoiceFile'
            invoiceFileType='1'
        }else if(items1.fileType == 'XML'){
            getListApi = 'post_ivatDownXmlInvoiceFile'
            invoiceFileType='3'
        }
        let invoiceIds = []
        websocketProgress()
        let ws // websocket
        function websocketProgress() {
            httpRequest.post_ivatSocketRequestId({requestType:'down'}).then((res) => {
                let response = res.data.value
                items1.requestId = response
                let isSuccess = false
                httpRequest[getListApi](items1).then((res) => {
                    isSuccess = true
                }).finally(() => {
                    isShow(isSuccess)
                })
                const _path = `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host === 'localhost:3000' ? '192.168.52.71' : location.host}/socket/ivatWebsocket/ivatInvoicePool/${response}`
                ws = new WebSocket(_path)
                console.log(ws)
                ws.onopen = function () {
                    console.log(_path)
                };
                ws.onerror = function (err) {
                    console.log(err)
                    logger.logError('下载任务因异常原因已中断。')
                    if($scope.allEleCount){
                        document.getElementById('showTitle').innerText = `您所选的票据数据中，包含${$scope.allEleCount}张全电发票，${$scope.notAllEleCount}张非全电票据，其中${$scope.notDownFileCount}张非全电发票无文件可下载。本次共计${$scope.count - $scope.notDownFileCount}条数据，下载任务因异常原因已中断，已下载${$scope.downCount}张发票文件。`
                    }else {
                        document.getElementById('showTitle').innerText = `您所选的票据数据中，包含0张全电发票，0张非全电票据，其中0张非全电发票无文件可下载。本次共计0条数据，下载任务因异常原因已中断，已下载0张发票文件。`
                    }
                    ws.close();
                    $scope.stopSynBtn = false //停止下载
                    $scope.returnBtn = true //返回列表
                };
                ws.onmessage = function (evt) {
                    let res = JSON.parse(evt.data)
                    console.log(res)
                    if(res.data.value.invoiceId){
                        invoiceIds.push(res.data.value.invoiceId)
                    }
                    if(res.data.msgCode === 2002 || res.data.msgCode === 2003){
                        $uibModalInstance.dismiss('cancel')
                        ws.close();
                        let startIndex = res.data.message.length-11
                        let endIndex = res.data.message.length
                        $uibModal.open({
                            template: authenticationModalTemplate,
                            controller: 'authenticationModalCtrl',
                            backdrop: 'static',
                            openedClass: 'mod-modal mod-modal-lg',
                            resolve: {
                                items1() {
                                    return {
                                        authorizeId: res.data.emsg,
                                        mobile: res.data.message.substring(startIndex,endIndex),
                                    }
                                },
                            },
                        })
                    }else if(res.data.success){
                        var num = 0
                        $scope.allEleCount = res.data.value.allEleCount //全电发票数量
                        $scope.count = res.data.value.count //下载合计数量
                        $scope.downCount = res.data.value.downCount //已下载数量
                        $scope.notAllEleCount = res.data.value.notAllEleCount //非全电发票数量
                        $scope.notDownFileCount = res.data.value.notDownFileCount //非全电发票无文件下载数量
                        $scope.processedCount = res.data.value.processedCount //已执行文件数量
                        if($scope.count === 0){
                            $scope.stopSynBtn = false //停止下载
                            $scope.returnBtn = true //返回列表
                            document.getElementById('btnText').innerText = `返回列表`
                            document.getElementById('showTitle').innerText = `您所选的票据数据中，包含0张全电发票，0张非全电票据，其中0张非全电发票无文件可下载。\n本次共计0条数据，已下载0张发票文件。`
                            document.getElementById('content').innerText = `100%`
                            ws.close();
                            return
                        }
                        num = $scope.processedCount / $scope.count * 700
                        document.getElementById('content').style.width = `${num}px`
                        var num1 = ($scope.processedCount / $scope.count * 100).toFixed(0)
                        document.getElementById('content').innerText = `${num1}%`
                        document.getElementById('showTitle').innerText = `您所选的票据数据中，包含${$scope.allEleCount}张全电发票，${$scope.notAllEleCount}张非全电票据，其中${$scope.notDownFileCount}张非全电发票无文件可下载。\n本次共计${$scope.count - $scope.notDownFileCount}条数据，已下载${$scope.downCount}张发票文件。`
                        document.getElementById('btnText').innerText = `停止下载`
                        if(num===700){
                            $scope.stopSynBtn = false //停止下载
                            $scope.returnBtn = true //返回列表
                            document.getElementById('btnText').innerText = `返回列表`
                            document.getElementById('showTitle').innerText = `您所选的票据数据中，包含${$scope.allEleCount}张全电发票，${$scope.notAllEleCount}张非全电票据，其中${$scope.notDownFileCount}张非全电发票无文件可下载。\n本次共计${$scope.count - $scope.notDownFileCount}条数据，下载任务已完成，已下载${$scope.downCount}张发票文件。`
                            ws.close();
                            if($scope.downCount > 0){
                                let requestId = items1.requestId
                                utils.post_downLoad({
                                    invoiceIds,
                                    invoiceFileType,
                                    requestId,
                                }, `${host.etcloudIvatApp}tax4/ivatTax4InvoicePool/downloadTax4InvoiceBach?accessToken=${localStorage.getItem('id_token')}`, '')
                            }
                        }
                    }else {
                        $scope.allEleCount = res.data.value.allEleCount //全电发票数量
                        $scope.count = res.data.value.count //下载合计数量
                        $scope.downCount = res.data.value.downCount //已下载数量
                        $scope.notAllEleCount = res.data.value.notAllEleCount //非全电发票数量
                        $scope.notDownFileCount = res.data.value.notDownFileCount //非全电发票无文件下载数量
                        $scope.processedCount = res.data.value.processedCount //已执行文件数量
                        document.getElementById('showTitle').innerText = `您所选的票据数据中，包含${$scope.allEleCount}张全电发票，${$scope.notAllEleCount}张非全电票据，其中${$scope.notDownFileCount}张非全电发票无文件可下载。\n本次共计${$scope.count - $scope.notDownFileCount}条数据，下载任务因异常原因已中断，已下载${$scope.downCount}张发票文件。`
                        document.getElementById('btnText').innerText = `返回列表`
                        if($scope.count === 0){
                            document.getElementById('content').innerText = `100%`
                            return
                        }
                        let num = $scope.processedCount / $scope.count * 700
                        document.getElementById('content').style.width = `${num}px`
                        let num1 = ($scope.processedCount / $scope.count * 100).toFixed(0)
                        document.getElementById('content').innerText = `${num1}%`
                        ws.close();
                        $scope.stopSynBtn = false //停止下载
                        $scope.returnBtn = true //返回列表
                        if($scope.downCount > 0){
                            let requestId = items1.requestId
                            utils.post_downLoad({
                                invoiceIds,
                                invoiceFileType,
                                requestId,
                            }, `${host.etcloudIvatApp}tax4/ivatTax4InvoicePool/downloadTax4InvoiceBach?accessToken=${localStorage.getItem('id_token')}`, '')
                        }
                    }
                };
            })
        }
        // 停止下载
        $scope.stopSyn = function (){
            if($scope.returnBtn){
                $uibModalInstance.close(items1.requestId)
            }else {
                if($scope.allEleCount){
                    document.getElementById('showTitle').innerText = `您所选的票据数据中，包含${$scope.allEleCount}张全电发票，${$scope.notAllEleCount}张非全电票据，其中${$scope.notDownFileCount}张非全电发票无文件可下载。\n本次共计${$scope.count}条数据，下载任务已暂停，已下载${$scope.downCount}张发票文件。`
                }else {
                    document.getElementById('showTitle').innerText = `您所选的票据数据中，包含0张全电发票，0张非全电票据，其中0张非全电发票无文件可下载。\n本次共计0条数据，下载任务已暂停，已下载0张发票文件。`
                }
                ws.close();
                httpRequest.get_ivatStopTask(items1.requestId).then((res) => {
                    $scope.stopSynBtn = false //停止下载
                    $scope.returnBtn = true //返回列表
                })
            }
        }
        function isShow(isSuccess){
            if(!isSuccess){
                $scope.cancel()
            }
        }
        // 关闭
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function (v) {
            $uibModalInstance.close(items1.requestId)
        }
    }
}

inputDownloadProgressCtrl.$inject = ['$scope', '$timeout', '$filter', '$uibModalInstance', 'logger', 'items1', 'httpRequest']
export default inputDownloadProgressCtrl



// WEBPACK FOOTER //
// ./src/app/input/invoicePool/inputInvoicePool/downloadProgressCtrl.js